import { useHttp } from '@/request';
import { useShopInfoStore } from '../store/shopInfoStore';
import { $k18n } from '@/common/i18n';
import { Toast } from '@kibt/meta-ui-krn';

const toastCode = function (code) {
    if (code) {
        setTimeout(() => {
            Toast.show(
                $k18n({
                    id: 'k_370316',
                    text: '部分商品信息有变更',
                }),
            );
        }, 1200);
    }
};

export function useQuery() {
    const { query, setQuery } = useShopInfoStore((state) => ({
        query: state.query,
        setQuery: state.setQuery,
    }));
    return { query, setQuery };
}

export function useGetStoreCartItem() {
    const { query } = useQuery();
    const setStoreCartItem = useShopInfoStore((state) => state.setStoreCartItem);

    const { loading, runAsync } = useHttp('POST/rest/o/ecommerce/customer/shopCart/storeCartItem', null, { manual: true });

    const loadShopData = () => {
        runAsync({
            query: {
                merchantId: query.merchantId,
                targetCouponBatchId: query.couponBatchId,
                sceneId: 41,
            },
        })
            .then((res: any) => {
                const validCartList = res.data?.cartShopList[0]?.cartItemList || [];
                const allList = validCartList.concat(res.data?.invalidCartItemList || []);
                if (res.data?.cartShopList[0]?.cartItemList) res.data.cartShopList[0].cartItemList = allList;
                setStoreCartItem(res?.data);
            })
            .catch(console.log);
    };

    return {
        loadShopData,
        loading,
    };
}

export function useSetCartItemNum() {
    const { loading, runAsync } = useHttp('POST/rest/o/ecommerce/customer/shopCart/setCartItemNum', null, { manual: true });
    const { setStoreCartItem, storeCartItem } = useShopInfoStore((state) => ({
        setStoreCartItem: state.setStoreCartItem,
        storeCartItem: state.storeCartItem,
    }));
    const { query } = useQuery();

    async function setCartItemNum(cartItemId: number, num: number, merchantId: number, selected = true) {
        const seletedItems = storeCartItem.cartShopList
            .find((v) => v.merchantId === merchantId)
            .cartItemList.filter((v) => v.isSelected)
            .map((v) => ({
                cartItemId: v.cartItemId,
                skuQuantity: v.cartItemId === cartItemId ? num : v.skuQuantity,
                showPrice: v.showPrice?.now?.amount,
                activityId: v?.flashSaleInfo?.activityId,
            }));
        try {
            const res = await runAsync({
                body: {
                    cartItemId,
                    skuQuantity: num,
                    selected: seletedItems,
                    targetCouponBatchId: query.couponBatchId,
                    sceneId: 41,
                },
            });
            // TODO: 后端接口会调整返回类型
            const shopEvaluate = res?.data?.shopUpdate?.shopEvaluate;
            if (!shopEvaluate) {
                Toast.show({ text: $k18n('操作失败') });
                return;
            }
            const newShopList = storeCartItem.cartShopList.map((shopItem) => {
                // 更新店铺数据
                const targetNewItem = selected ? shopEvaluate[shopItem.merchantId] : shopItem.shopEvaluate;
                return {
                    ...shopItem,
                    cartItemList: shopItem.cartItemList.map((cartItem) => {
                        // 更新选中商品信息
                        let _cartItem = { ...cartItem };
                        if (targetNewItem) {
                            const newCartItem = targetNewItem?.skuDiscount?.[cartItem.skuId];
                            if (newCartItem) {
                                _cartItem = {
                                    ..._cartItem,
                                    ...newCartItem,
                                    flashSaleInfo: newCartItem.flashSaleInfo,
                                };
                            }
                        }

                        if (cartItem.cartItemId !== cartItemId) return _cartItem;
                        return {
                            ..._cartItem,
                            // 调整数量成功，更新数量
                            skuQuantity: res?.data?.skuQuantity,
                            // 修改数量成功，status置为1
                            status: 1,
                        };
                    }),
                    shopEvaluate: targetNewItem,
                };
            });
            toastCode(res?.data?.shopUpdate?.toastCode);
            // setSelectedInsufficient(res?.data?.shopUpdate?.selectedInsufficient ? true : false)

            // setCartShopList(newShopList);
            // storeCartItem.cartShopList = newShopList; // todo 这么写没问题么
            setStoreCartItem({
                ...storeCartItem,
                cartShopList: newShopList,
            });
        } catch (error) {
            // 别删！！！！！
            if (error.result === 8306) {
                const newSkuQuantity = error?.data?.skuQuantity as number;
                if (newSkuQuantity !== undefined) {
                    setCartItemNum(cartItemId, newSkuQuantity, merchantId);
                }
            } else {
                // Toast.show({ text: getNetworkErrorMessage(error, $k18n('操作失败')) });
            }
        }
    }
    return {
        setCartItemNum,
        loading,
    };
}

export function useDelSelectProductItem() {
    type Res = any;
    const { setStoreCartItem, storeCartItem } = useShopInfoStore((state) => ({
        setStoreCartItem: state.setStoreCartItem,
        storeCartItem: state.storeCartItem,
    }));
    const { loading, runAsync } = useHttp('POST/rest/o/ecommerce/customer/shopCart/removeCartItem', null, { manual: true });
    const { runAsync: loadShopData } = useHttp('POST/rest/o/ecommerce/customer/shopCart/storeCartItem', null, { manual: true });
    const { query } = useQuery();

    function delShopCardList(resDatas: Res, id: number) {
        const newShopList = storeCartItem.cartShopList
            .map((shop) => {
                // 先删掉指定商品
                return {
                    ...shop,
                    cartItemList: shop.cartItemList.filter((item) => item.cartItemId !== id),
                };
            })
            .filter((v) => v.cartItemList.length > 0)
            .map((shopItem) => {
                // 再更新店铺信息
                const targetNewItem = resDatas?.shopUpdate?.shopEvaluate[shopItem.merchantId];
                return {
                    ...shopItem,
                    shopEvaluate: targetNewItem,
                };
            });

        // setSelectedInsufficient(resDatas?.shopUpdate?.selectedInsufficient ? true : false)

        // setCartShopList(newShopList);
        storeCartItem.cartShopList = newShopList; // todo 这么写没问题么
        setStoreCartItem(storeCartItem);

        // setTotalSkuNum(totalSkuNum > 0 ? totalSkuNum - 1 : 0);
    }
    async function deleteProductItem(id: number, merchantId: number) {
        if (loading) {
            return Toast.show({ text: $k18n('您的操作太频繁了') });
        }
        const seletedItems = storeCartItem.cartShopList
            .find((v) => v.merchantId === merchantId)
            .cartItemList.filter((v) => v.isSelected)
            .map((v) => ({
                cartItemId: v.cartItemId,
                skuQuantity: v.skuQuantity,
                showPrice: v.showPrice?.now?.amount,
                activityId: v?.flashSaleInfo?.activityId,
            }));
        try {
            const res = await runAsync({
                body: {
                    removeIds: [id],
                    selected: seletedItems,
                    targetCouponBatchId: query.couponBatchId,
                    sceneId: 41,
                },
            });
            loadShopData({
                query: {
                    merchantId: query.merchantId,
                    targetCouponBatchId: query.couponBatchId,
                    sceneId: 41,
                },
            })
                .then((res: any) => {
                    const validCartList = res.data?.cartShopList[0]?.cartItemList || [];
                    const allList = validCartList.concat(res.data?.invalidCartItemList || []);
                    if (res.data?.cartShopList[0]?.cartItemList) res.data.cartShopList[0].cartItemList = allList;
                    setStoreCartItem(res?.data);
                })
                .catch(console.log);
            Toast.show({ text: $k18n('删除成功') });
        } catch (error) {
            // Toast.show({ text: getNetworkErrorMessage(error, $k18n('删除失败')) });
        }
    }

    return {
        deleteProductItem,
        loading,
    };
}

export function useSelectProducts() {
    // const curAddress = useStore((s) => s.curAddress);
    // const pageInfo = useStore((s) => s.pageInfo);
    // const { cartShopList, setCartShopList,setSelectedInsufficient } = useStore((s) => ({ cartShopList: s.cartShopList, setCartShopList: s.setCartShopList,setSelectedInsufficient:s.setSelectedInsufficient }));
    const { loading, runAsync } = useHttp('POST/rest/o/ecommerce/customer/shopCart/setSelectCartItem', null, { manual: true });
    const { setStoreCartItem, storeCartItem } = useShopInfoStore((state) => ({
        setStoreCartItem: state.setStoreCartItem,
        storeCartItem: state.storeCartItem,
    }));
    const { query } = useQuery();
    async function selectProductItem(ids: number[], checked: boolean, isSingleCheck?: boolean) {
        const targetCartShop = storeCartItem.cartShopList.find((v) => v.cartItemList.some((item) => ids.includes(item.cartItemId)));
        const seletedItems = targetCartShop.cartItemList
            .filter((v) => {
                // 选中时将此店铺已选的和点击的这个商品筛选出来
                if (checked) return v.isSelected || ids.includes(v.cartItemId);
                // 取消选中时将此店铺已选但不包含在反选的商品筛选出来
                return !ids.includes(v.cartItemId) && v.isSelected;
            })
            .map((v) => ({
                cartItemId: v.cartItemId,
                skuQuantity: v.skuQuantity,
                showPrice: v.showPrice?.now?.amount,
                activityId: v?.flashSaleInfo?.activityId,
            }));
        if (checked && seletedItems.length > storeCartItem.selectedLimit) {
            return Toast.show({ text: $k18n({ text: '最多选择{num}个商品', params: { num: storeCartItem.selectedLimit } }) });
        }
        if (loading) {
            return Toast.show({ text: $k18n('您的操作太频繁了') });
        }
        try {
            const res = await runAsync({
                body: {
                    singleSelectId: isSingleCheck && checked ? ids[0] : null,
                    selected: seletedItems,
                    targetCouponBatchId: query.couponBatchId,
                    sceneId: 41,
                },
            });
            const newData = res?.data;
            // if (!newData?.shopUpdate?.shopEvaluate) {
            //     Toast.error($k18n('操作失败'));
            //     return;
            // }
            const newShopList = storeCartItem.cartShopList.map((shopItem) => {
                // 非本店铺的全变为未选
                if (shopItem.merchantId !== targetCartShop.merchantId) {
                    return {
                        ...shopItem,
                        cartItemList: shopItem.cartItemList.map((v) => ({ ...v, isSelected: false })),
                    };
                }
                // 更新此店铺数据
                const targetNewItem = newData?.shopUpdate?.shopEvaluate?.[shopItem.merchantId];
                return {
                    ...shopItem,
                    cartItemList: shopItem.cartItemList.map((v) => {
                        const skuItemObj = targetNewItem?.skuDiscount || {};
                        const newItem = skuItemObj[v.skuId];
                        if (newItem) {
                            return {
                                ...v,
                                ...newItem,
                                flashSaleInfo: newItem.flashSaleInfo,
                                isSelected: true,
                            };
                        } else {
                            return {
                                ...v,
                                isSelected: false,
                            };
                        }
                    }),
                    shopEvaluate: targetNewItem,
                };
            });

            toastCode(newData?.shopUpdate?.toastCode);
            // setSelectedInsufficient(newData?.shopUpdate?.selectedInsufficient ? true : false)

            // setCartShopList(newShopList);
            storeCartItem.cartShopList = newShopList; // todo 这么写没问题么
            setStoreCartItem(storeCartItem);
        } catch (error) {
            // Toast.show({ text: getNetworkErrorMessage(error, $k18n('操作失败')) });
        }
    }
    return {
        selectProductItem,
        loading,
    };
}
